const Contact = () => {
  return (
    <div>
      <div
        className="flex flex-col items-center mt-14"
        style={{ height: "500px" }}
      >
        <div className="text-4xl md:text-6xl mb-4">Contact</div>
        <hr className="w-20 md:w-40 border-yellow-500 border-2 md:border-4 mb-4" />
      </div>
    </div>
  );
};

export default Contact;
